import styled from "styled-components";

export const VideosPageWrapper = styled.div`
  .ant-card {
    box-shadow: none !important;
    border: 1px solid var(--border-color) !important;
  }
  .ant-card-cover img{
    border-radius: 10px !important;
  }
  .ant-select-selector {
    border-radius: 6px;
    height: 40px;
    align-items: center;
    border: 1px solid #8a3ef4;
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: #8a3ef4 !important;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 6px;
    height: 43px;
    align-items: center;
    background-color: transparent;
    border: 1px solid var(--border-color) !important;
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector{
    border-color: #8a3ef4 !important;
  }
  .ant-select{
    background-color: var(--primary-bg);
    color: var(--primary-text-color);
    font-size: 16px;
  }
  .ant-select-arrow{
    color: var(--primary-text-color);
  }
  .ant-input {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: "tnum", "tnum";
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 11px;
    // color: var(--text-primary) !important;
    font-size: 14px;
    line-height: 1.5715;
    background-image: none;
    border-radius: 6px;
    height: 40px;
    transition: all 0.3s;
  }
  .ant-input:focus,
  .ant-input:hover {
    border-color: #8a3ef4 !important;
    color: #000;
  }
  .ant-input::placeholder{
    color: var(--secondary-text-color) !important;
  }
`;

export const AnimatedDeleteButton = styled.div`
display: inline-flex;
align-items: center;
border: 1px solid #ff4d4f;
border-radius: 6px;
background: transparent;
color: #ff4d4f;
cursor: pointer;
padding: 0px 7px;
height: 32px;
min-width: 32px;
max-width: 32px;
overflow: hidden;
transition: max-width 0.3s cubic-bezier(.4,0,.2,1), background 0.3s, border 0.3s;
white-space: nowrap;
font-size: 16px;

.delete-text {
  opacity: 0;
  margin-left: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #ff4d4f;
  transition: opacity 0.2s, transform 0.2s;
  transform: translateX(-10px);
  pointer-events: none;
}

&:hover {
  max-width: 110px;
  background: var(--primary-bg);
}

&:hover .delete-text {
  opacity: 1;
  transform: translateX(0);
}
`;